import React, { useContext, useState } from "react";
import {
  Box,
  Text,
  IconButton,
  Button,
  OriginLogo,
} from "@origin-digital/ods-core";
import { IconClose, IconMenu } from "@origin-digital/ods-icons";
import { Drawer, Link } from "@mui/material";
import { pageHeaderZIndex } from "src/constants";
import { AppContext } from "src/context/AppContext";
import envConfig from "../../../envConfig/envHelper";
import NavSectionBelowLg from "../NavSection/NavSection.belowLg";
import { useShouldShowPrivateElements } from "./useShouldShowPrivateElements";

export const HeaderBarBelowLg = ({ isOpen = false }: { isOpen?: boolean }) => {
  const shouldShowPrivateElements = useShouldShowPrivateElements();
  const [open, setOpen] = useState(isOpen);

  const {
    context: { user },
  } = useContext(AppContext);

  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };

  const PrivateRouteLogo = () => (
    <Box paddingY="medium">
      <Link href={envConfig.config.homeUrl} underline="none">
        <Box display="flex" gap="xsmall">
          <img
            width="24"
            height="24"
            src="https://www.originenergy.com.au/cdn/images/originenergy/image/upload/logos/origin_favicon-32x32.svg"
            alt="Origin Connect"
          />
          <Text weight="medium" tone="neutralDark">
            Origin Connect
          </Text>
        </Box>
      </Link>
    </Box>
  );

  const PublicRouteLogo = () => <OriginLogo variant="portrait" />;
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      backgroundColor="white"
      paddingX="small"
      paddingY="none"
      width="full"
      position="fixed"
      style={{ borderBottom: "solid 1px #e3e3e3", zIndex: pageHeaderZIndex }}
    >
      <Box display="flex" alignItems="center" justifyContent="flex-start">
        {shouldShowPrivateElements ? <PrivateRouteLogo /> : <PublicRouteLogo />}
      </Box>
      {user?.role && shouldShowPrivateElements ? (
        <>
          <Button
            onClick={toggleDrawer(true)}
            variant="outlined"
            size="small"
            icon={<IconMenu color="inherit" />}
          >
            Menu
          </Button>
          <Drawer anchor="right" open={open} onClose={toggleDrawer(false)}>
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="space-between"
              height="full"
              paddingTop="small"
              paddingBottom="large"
              style={{ width: "320px" }}
            >
              <Box
                display="flex"
                flexDirection="column"
                alignItems="flex-end"
                justifyContent="flex-end"
              >
                <Box paddingRight="xsmall">
                  <IconButton
                    onClick={toggleDrawer(false)}
                    aria-label="Close menu"
                  >
                    <IconClose size="xsmall" color="grey300" />
                  </IconButton>
                </Box>
                <NavSectionBelowLg toggleDrawer={toggleDrawer} />
              </Box>
              <Box
                paddingX="medium"
                display="flex"
                flexDirection="column"
                gap="xxsmall"
              >
                <Text variant="body-small" weight="medium" truncate>
                  {user?.first_name} {user?.last_name}
                </Text>
                <Text variant="body-small" tone="neutralLight" truncate>
                  {user?.role.toLowerCase().includes("origin") ||
                  !user?.main_company
                    ? ""
                    : user?.main_company.name}
                </Text>
              </Box>
            </Box>
          </Drawer>
        </>
      ) : null}
    </Box>
  );
};
